import { render } from "./FicheEleve.vue?vue&type=template&id=5b66b356&scoped=true"
import script from "./FicheEleve.vue?vue&type=script&lang=js"
export * from "./FicheEleve.vue?vue&type=script&lang=js"

import "./FicheEleve.vue?vue&type=style&index=0&id=5b66b356&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b66b356"]])

export default __exports__